import axios from "axios";
const createDoc3 = async (values: {
  checkBox: [];
  sendBy: string;
  manage: string;
  doc5: [];
  teacher: [];
  kpi: [];
  schedule: number;
  course: number;
  upload: any;
}) => {
  // values.upload[0].response.filename)
  // console.log(values);

  const checkField = (array: [], key: string) => {
    //เอา คีย์ไปค้น ถ้าเจอ ก็ตอบ ture ไม่เจอก็ false
    return array.find((x) => x === key) ? true : false;
  };

  const data = {
    activitySTD: checkField(values.checkBox, "activitySTD"),
    manage: values.manage,

    sendBy: values.sendBy,
    // kpi1: checkField(values.checkBox, "kpi1"),
    // kpi2: checkField(values.checkBox, "kpi2"),
    // kpi3: checkField(values.checkBox, "kpi3"),
    // kpi4: checkField(values.checkBox, "kpi4"),
    doc5: values.doc5.toString(),
    teacher: values.teacher.toString(),
    schedule: { id: values.schedule },
    course: { id: values.course },
    pathFile: values.upload[0].response.filename,
    kpi: values.kpi.toString(),
  };

  // console.log(data);

  return await axios.post(`doc3`, data);
};

const checkSend = (schedule: number, course: number) => {
  // console.log(schedule + "<<>>" + course);
  // console.log(course);

  return axios.post("doc3/checkSend", { schedule, course });
};

const getById = async (id: number) => {
  return await axios.get(`doc3/${id}`);
};

const delele = async (id: number) => {
  return await axios.delete(`doc3/${id}`);
};

const findDoc3 = async (body: {
  CourseName: string;
  courseCode: string;
  year: string;
  term: string;
  curriId: string;
  type: string;
}) => {
  return await axios.post(`doc3/finddoc3`, body);
};

const doc3All = async () => {
  return await axios.get("doc3");
};

const countSend = async (curriId: number, scheId: number) => {
  return await axios.post("doc3/findbycurri", { curriId, scheId });
};

const Doc3Service = {
  createDoc3,
  checkSend,
  delele,
  getById,
  findDoc3,
  doc3All,
  countSend,
};
export default Doc3Service;
